module.exports = __webpack_public_path__ + "img/C06TechCultivation_ua.4b2ff576.webp";